// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2LydA","inner":"Footer_inner__30BWv"};